import { PropsWithChildren } from "react";
import Title from "./Title";
import { cn } from "@/lib/utils";

interface SectionProps extends PropsWithChildren {
  title?: string;
  titleLevel?: 1 | 2 | 3 | 4;
  className?: string;
}

const Section = ({
  children,
  title,
  titleLevel = 4,
  className,
}: SectionProps) => {
  return (
    <section className={cn("my-4", className)}>
      {title && <Title level={titleLevel}>{title}</Title>}
      {children}
    </section>
  );
};

export default Section;
